<template>
  <v-card>
    <v-card-title primary-title style="display: flex; align-items: center; justify-content: space-between">
      <h2>Players' Statistics</h2>
    </v-card-title>
    <v-card-title style="display: flex; align-items: center; padding: 0 16px">
      <v-select
        style="margin-right: 20px; width: 20%; flex: inherit"
        v-model="selectedType"
        :items="typeSelector"
      ></v-select>
      <v-select
        style="margin-right: 20px; width: 20%; flex: inherit"
        v-model="selectedCountry"
        :items="countrySelector"
      ></v-select>
    </v-card-title>


    <best-scorer v-if="selectedType === 1" :statistics="filteredData" :tournamentId="tournamentId"></best-scorer>
    <best-spiker v-if="selectedType === 2" :statistics="filteredData" :tournamentId="tournamentId"></best-spiker>
    <best-blocker v-if="selectedType === 3" :statistics="filteredData" :tournamentId="tournamentId"></best-blocker>
    <best-server v-if="selectedType === 4" :statistics="filteredData" :tournamentId="tournamentId"></best-server>
    <best-setter v-if="selectedType === 5" :statistics="filteredData" :tournamentId="tournamentId"></best-setter>
    <best-digger v-if="selectedType === 6" :statistics="filteredData" :tournamentId="tournamentId"></best-digger>
    <best-receiver v-if="selectedType === 7" :statistics="filteredData" :tournamentId="tournamentId"></best-receiver>
  </v-card>
</template>

<script>
import { Request, QueryBuilder } from '@fivb/sdk'

import BestScorer from './BestScorer'
import BestSpiker from './BestSpiker'
import BestBlocker from './BestBlocker'
import BestServer from './BestServer'
import BestSetter from './BestSetter'
import BestDigger from './BestDigger'
import BestReceiver from './BestReceiver'

export default {
  props: ['tournamentId'],

  components: {
    BestScorer,
    BestSpiker,
    BestBlocker,
    BestServer,
    BestSetter,
    BestDigger,
    BestReceiver,
  },

  data: () => ({
    data: [],
    selectedCountry: -1,
    countrySelector: [
      { text: 'All countries', value: -1, }
    ],
    selectedType: 1,
    typeSelector: [
      { text: 'Best Scorers', value: 1 },
      { text: 'Best Attackers', value: 2 },
      { text: 'Best Blockers', value: 3 },
      { text: 'Best Servers', value: 4 },
      { text: 'Best Setters', value: 5 },
      { text: 'Best Diggers', value: 6 },
      { text: 'Best Receivers', value: 7 },
    ],
  }),

  async created () {
    const query = new Request('GetVolleyStatisticList')
      .addAttribute('Fields', 'No NoShirt NoItem BlockContinue BlockFault BlockPoint BlockTotal DigContinue DigExcellent DigFault DigTotal ReceptionContinue NbRallies ReceptionExcellent ReceptionFault ReceptionTotal ServeContinue ServeFault ServePoint ServeTotal SetContinue SetExcellent SetFault SetTotal SpikeContinue SpikeFault SpikePoint SpikeTotal AttemptTotal PointTotal TeamFault OpponentError')
      .addAttribute('SumBy', 'Tournament')
      .addFilter('NoTournaments', this.tournamentId)
      .addFilter('MatchesToUse', 'MatchesStarted')
      .addRelation('Player', { fields: ['No', 'TeamName', 'FederationCode'] })
      .toString()

    const { data } = await this.fetchData(query)

    this.data = data.filter((stat) => {
      return stat.player !== null
    })

    this.fetchCountries()
  },

  computed: {
    filteredData () {
      if (this.selectedCountry === -1) {
        return this.data
      }

      return this.data.filter((stat) => {
        return stat.player.federationCode === this.selectedCountry
      })
    },
  },

  methods: {
    async fetchCountries () {
      const query = new QueryBuilder('VolleyTeam')
        .filterBy('NoTournament', this.tournamentId)
        .fetch(['Name', 'Code'])

      const { data } = await this.fetchData(query)

      data.forEach((country) => {
        this.countrySelector.push({ text: country.name, value: country.code })
      })
    },

    fetchData (query) {
      return fetch(process.env.VUE_APP_FIVB_API_URL, {
        method: 'POST',
        mode: 'cors',
        cache: 'no-store',
        headers: new Headers({
          'Content-Type': 'application/xml',
          'Accept': 'application/json',
          'X-FIVB-App-ID': '3b665ad61056495ab5514b81eb0562d8'
        }),
        body: query,
      }).then(response => response.json())
    }
  },
}
</script>




// WEBPACK FOOTER //
// src/components/TournamentMatchList/StatisticsByPlayer/StatisticsByPlayer.vue